<template>
    <div class="elle-google-rate" :class="[style]">
        <div class="rate-icon">
            <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.0052 0C7.16654 0 0 7.164 0 16C0 24.836 7.16654 32 16.0052 32C29.3519 32 32.3588 19.6093 31.1068 13.3333H29.3333H26.3099H16V18.6667H26.3177C25.1316 23.2643 20.9679 26.6667 16 26.6667C10.1093 26.6667 5.33333 21.8907 5.33333 16C5.33333 10.1093 10.1093 5.33333 16 5.33333C18.6787 5.33333 21.1189 6.32767 22.9922 7.95833L26.7813 4.17188C23.9359 1.57988 20.1559 0 16.0052 0Z"
                    fill="black"
                />
            </svg>
        </div>
        <div class="rate-statistics">
            <div class="rate">
                <div class="rate-number">{{ rating.ratingAmount }}</div>
                <div ref="$stars" class="rate-stars">
                    <span v-for="i in 5" :key="i">
                        <svg viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M7.10326 0.816985C7.47008 0.0737391 8.52992 0.07374 8.89674 0.816986L10.4124 3.88798C10.558 4.18313 10.8396 4.38769 11.1653 4.43502L14.5543 4.92748C15.3746 5.04667 15.7021 6.05464 15.1086 6.63317L12.6562 9.02361C12.4205 9.25335 12.313 9.58435 12.3686 9.90874L12.9475 13.2841C13.0877 14.101 12.2302 14.724 11.4966 14.3383L8.46534 12.7446C8.17402 12.5915 7.82598 12.5915 7.53466 12.7446L4.5034 14.3383C3.76978 14.724 2.91235 14.101 3.05246 13.2841L3.63137 9.90874C3.68701 9.58435 3.57946 9.25335 3.34378 9.02361L0.89144 6.63317C0.297923 6.05464 0.625434 5.04667 1.44565 4.92748L4.8347 4.43502C5.16041 4.38769 5.44197 4.18313 5.58764 3.88798L7.10326 0.816985Z"
                                fill="black"
                            />
                        </svg>
                    </span>
                </div>
            </div>
            <div class="amount">{{ rating.reviewsAmount }} reviews</div>
        </div>
    </div>
</template>

<script setup lang="ts">
const props = defineProps({
    rating: {
        type: Object,
        default: () => ({})
    },
    style: {
        type: String,
        default: () => ''
    }
});

const { $gsap: gsap } = useNuxtApp();
const $stars = ref(null);

onMounted(() => {
    gsap.set($stars.value, {
        '--el-stars-cover': `${100 - (parseFloat(props.rating.ratingAmount) / 5) * 100}%`
    });
});
</script>
